import clsx from "clsx";
import { useFormContext } from "react-hook-form";
import style from "./ManualMailingAddress.module.css";
import { countryList, americanStateList, streetTypeList } from "@/lib/util";
import { EnglishStr } from "@/lib/EnglishStr";
import { useEffect, useState } from "react";
import { addressInfo } from "@/slices/PreviousAddressSlice";
import { RootState } from "@/store/dtm";
import { useSelector } from "react-redux";

export default function ManualAddress(props: any) {
  const methods = useFormContext();

  const getCountry = countryList();
  const getNACountry = countryList(false, true);
  const getStates = americanStateList();
  const getStreetTypes = streetTypeList();

  const [stateListType, setStateListType] = useState(1); //1 Canadian Provinces, 2 American States
  const [addressInfo, setAddressInfo] = useState<addressInfo>({
    id: 0,
    displayId: "",
    streetNumber: "",
    streetName: "",
    streetType: "",
    streetDirection: "",
    city: "",
    province: "",
    country: "",
    postalCode: "",
    unitType: "",
    unitNumber: "",
    manualAddressEntered: true,
    yearsLivedOn: 0,
    monthsLivedOn: 0
  });

  const [addressErrors, setAddressErrors] = useState<string[] | undefined>(undefined);
  const [focusErrorType, setFocusErrorType] = useState(0);
  const [highlightError, setHighlightError] = useState(0);

  const applicant = useSelector(
    (state: RootState) => state.applicant.applicant
  );

  const handleCaChange = (ev: any) => {
    if (ev.target.value === "Canada") {
      setStateListType(1);
      methods.register("provinceName", {
        required: "Select your province name",
      });
      methods.register("postalCode", {
        required: "Enter your postal code",
      });
    } else if (ev.target.value === "United States") {
      setStateListType(2);
      methods.register("provinceName", {
        required: "Select your state name",
      });
      methods.register("postalCode", {
        required: "Enter your zip code",
      });
    } else {
      setStateListType(0);
      methods.unregister("provinceName");
      methods.unregister("postalCode");
    }
  };

  useEffect(() => {
    if (props.addressData != undefined && props.addressData != "") {
      setAddressInfo(props.addressData);
    }

    if (props.addressData?.country == "Canada") {
      setStateListType(1);
    } else if (props.addressData?.country == "United States") {
      setStateListType(2);
    } else {
      setStateListType(0);
    }
  }, [props.manualAddressToggled, props.addressData]);

  useEffect(() => {
    if (props.addressErrors != undefined && props.errorIndex != undefined) {
      setAddressErrors(props.addressErrors[props.errorIndex]);
    }

  }, [props.addressErrors]);

  useEffect(() => {

  }, [addressErrors]);

  useEffect(() => {
    if (props.focusErrorType != undefined) {
      setFocusErrorType(props.focusErrorType);
    }

  }, [props.focusErrorType]);

  useEffect(() => {
    if (props.highlightError != undefined) {
      setHighlightError(props.highlightError);
    }

  }, [props.highlightError]);

  return (
    <>
      <div className="flex md:flex-row flex-col w-max">
        <div className={clsx("mt-5", focusErrorType == 1 ? "animate__animated animate__pulse" : "")}>
          <label htmlFor="streetNumber">Street number</label>
          <div className="flex relative">
            <span>
              <img
                src="assets/error-icon.svg"
                className={clsx(
                  methods.formState?.errors?.streetNumber?.message || addressErrors?.includes("streetNumber")
                    ? ""
                    : "hidden",
                  "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[195px]"
                )}
                alt="error"
                height={5}
                width={5}
              />
            </span>
            <input
              id="streetNumber"
              type="text"
              className={clsx(
                methods.formState?.errors?.streetNumber?.message || addressErrors?.includes("streetNumber") ? "error" : "",
                highlightError == 1 ? style.focusError : "",
                "mt-2 w:[200px] md:w-[222px]"
              )}
              value={addressInfo.streetNumber}
              maxLength={6}
              onChange={(e) => {
                let currentInfo = { ...addressInfo }
                currentInfo.streetNumber = e.target.value
                setAddressInfo(currentInfo);
                methods.setValue("streetNumber", e.target.value);
                methods.clearErrors("streetNumber");
                setHighlightError(0);
              }}
              onBlur={(e) => {
                if (props.addressData != undefined && props.passAddressData != undefined) {
                  props.passAddressData(props.addressData.displayId, "streetNumber", e.target.value);
                }
              }}
            />
          </div>
          {methods.formState?.errors?.streetNumber?.message && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              {methods.formState?.errors?.streetNumber?.message.toString()}
            </span>
          )}
          {addressErrors?.includes("streetNumber") && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              Street number is required
            </span>
          )}
        </div>
        <div className="md:ml-4 mt-5">
          <label htmlFor="unit-type">Unit Type (if applicable)</label>
          <div className="flex relative">
            <span>
              <img
                src="assets/error-icon.svg"
                className={clsx(
                  methods.formState?.errors?.unitType || addressErrors?.includes("unitType") ? "" : "hidden",
                  "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[185px]"
                )}
                alt="error"
                height={5}
                width={5}
              />
            </span>
            <select
              id="unitType"
              className={clsx(
                methods.formState?.errors?.unitType || addressErrors?.includes("unitType") ? "error" : "",
                "mt-2 w:[200px] md:w-[222px] pt-2.5",
                style.countryOption
              )}
              value={addressInfo.unitType}
              onChange={(e) => {
                let currentInfo = { ...addressInfo }
                currentInfo.unitType = e.target.value
                setAddressInfo(currentInfo);
                methods.setValue("unitType", e.target.value);
                if (props.addressData != undefined && props.passAddressData != undefined) {
                  props.passAddressData(props.addressData.displayId, "unitType", e.target.value);
                }
                if (addressErrors == undefined) {
                  //Only unregsiter if unit number field is empty
                  if (e.target.value.trim() == "" && (methods.getValues("unitNumber") == undefined || methods.getValues("unitNumber").trim() == "")) {
                    methods.unregister("unitNumber");
                  } else {
                    methods.register("unitNumber", {
                      required: "Enter your unit number",
                      pattern: {
                        value: /^[ #a-zA-Z0-9._-]+$/,
                        message: " Please enter a valid unit number",
                      },
                    });
                  }
                }
              }}
            >
              <option hidden value=""> Unit Type</option>
              <option value=" "></option>
              <option value="apt"> APT</option>
              <option value="unit"> UNIT</option>
              <option value="suite"> SUITE</option>
            </select>
          </div>
          {methods.formState?.errors?.unitType?.message && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              {methods.formState?.errors?.unitType?.message.toString()}
            </span>
          )}
          {addressErrors?.includes("unitType") && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              Unit type is required.
            </span>
          )}
        </div>
        <div className={clsx("md:ml-4 mt-5", focusErrorType == 2 ? "animate__animated animate__pulse" : "")}>
          <label htmlFor="unitNumber">Unit number (if applicable)</label>
          <div className="flex relative">
            <span>
              <img
                src="assets/error-icon.svg"
                className={clsx(
                  methods.formState?.errors?.unitNumber?.message || addressErrors?.includes("unitNumber")
                    ? ""
                    : "hidden",
                  "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[195px]"
                )}
                alt="error"
                height={5}
                width={5}
              />
            </span>
            <input
              id="unitNumber"
              type="text"
              className={clsx(methods.formState?.errors?.unitNumber?.message || addressErrors?.includes("unitNumber") ? "error" : "",
                "mt-2 w:[200px] md:w-[222px]",
                highlightError == 2 ? style.focusError : "")}
              value={addressInfo.unitNumber}
              maxLength={5}
              onChange={(e) => {
                let currentInfo = { ...addressInfo }
                currentInfo.unitNumber = e.target.value
                setAddressInfo(currentInfo);
                methods.setValue("unitNumber", e.target.value);
                methods.clearErrors("unitNumber");
                setHighlightError(0);
                if (e.target.value.trim() != "") {
                  methods.register("unitType", {
                    required: "Select a unit type",
                    pattern: {
                      value: /^[ #a-zA-Z0-9._-]+$/,
                      message: "Select a unit type",
                    },
                  });
                  methods.setValue("unitType", addressInfo.unitType ? addressInfo.unitType : "");
                } else {
                  //Only unregister if unit type is empty or deselected
                  if (methods.getValues("unitType") == undefined || methods.getValues("unitType").trim() == "") {
                    methods.unregister("unitType");
                    methods.unregister("unitNumber");
                  }
                }

              }}
              onBlur={(e) => {
                if (props.addressData != undefined && props.passAddressData != undefined) {
                  props.passAddressData(props.addressData.displayId, "unitNumber", e.target.value);
                }
              }}
            />
          </div>
          {methods.formState?.errors?.unitNumber?.message && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1" style={{ whiteSpace: "pre-line" }}>
              {methods.formState?.errors?.unitNumber?.message?.toString()}
            </span>
          )}
          {addressErrors?.includes("unitNumber") && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              Unit number is required
            </span>
          )}
        </div>
      </div>
      <div className="flex md:flex-row flex-col w-max">
        <div className={clsx("mt-5", focusErrorType == 3 ? "animate__animated animate__pulse" : "")}>
          <label htmlFor="street-address">Street name</label>
          <div className="flex relative">
            <span>
              <img
                src="assets/error-icon.svg"
                className={clsx(
                  methods.formState?.errors?.streetName || addressErrors?.includes("streetName") ? "" : "hidden",
                  "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[195px]"
                )}
                alt="error"
                height={5}
                width={5}
              />
            </span>
            <input
              className={clsx(
                methods.formState?.errors?.streetName?.message || addressErrors?.includes("streetName") ? "error" : "",
                "mt-2 w:[200px] md:w-[222px]", highlightError == 3 ? style.focusError : ""
              )}
              value={addressInfo.streetName}
              maxLength={23}
              onChange={(e) => {
                let currentInfo = { ...addressInfo }
                currentInfo.streetName = e.target.value
                setAddressInfo(currentInfo);
                methods.setValue("streetName", e.target.value);
                methods.clearErrors("streetName");
                setHighlightError(0);
              }}
              onBlur={(e) => {
                if (props.addressData != undefined && props.passAddressData != undefined) {
                  props.passAddressData(props.addressData.displayId, "streetName", e.target.value);
                }
              }}
              type="text"
              id="street-address"
            />
          </div>
          {methods.formState?.errors?.streetName?.message && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              {methods.formState?.errors?.streetName?.message.toString()}
            </span>
          )}
          {addressErrors?.includes("streetName") && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              Street name is required
            </span>
          )}
        </div>
        <div className={clsx("md:ml-4 mt-5", focusErrorType == 4 ? "animate__animated animate__pulse" : "")}>
          <label htmlFor="street-type">Street type</label>
          <div className="flex relative">
            <span>
              <img
                src="assets/error-icon.svg"
                className={clsx(
                  methods.formState?.errors?.streetType || addressErrors?.includes("streetType") ? "" : "hidden",
                  "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[185px]"
                )}
                alt="error"
                height={5}
                width={5}
              />
            </span>
            <select
              id="streetType"
              className={clsx(
                methods.formState?.errors?.streetType || addressErrors?.includes("streetType") ? "error" : "",
                "mt-2 w:[200px] md:w-[222px] pt-2.5", highlightError == 4 ? style.focusError : "",
                style.countryOption
              )}
              value={addressInfo.streetType}
              onChange={(e) => {
                let currentInfo = { ...addressInfo }
                currentInfo.streetType = e.target.value
                setAddressInfo(currentInfo);
                methods.setValue("streetType", e.target.value);
                if (props.addressData != undefined && props.passAddressData != undefined) {
                  props.passAddressData(props.addressData.displayId, "streetType", e.target.value);
                }
                methods.clearErrors("streetType");
                setHighlightError(0);
              }}
            >
              <option hidden value="">
                Street Type
              </option>
              <option value=" "></option>
              {getStreetTypes}
            </select>
          </div>
          {methods.formState?.errors?.streetType?.message && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              {methods.formState?.errors?.streetType?.message.toString()}
            </span>
          )}
          {addressErrors?.includes("streetType") && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              Select a street type
            </span>
          )}
        </div>
        <div className="md:ml-4 mt-5">
          <label htmlFor="street-direction">Street direction (optional)</label>
          <div className="flex relative">
            <select
              id="streetDirection"
              className={clsx(
                "mt-2 w:[200px] md:w-[222px] pt-2.5",
                style.countryOption
              )}
              value={addressInfo.streetDirection}
              onChange={(e) => {
                let currentInfo = { ...addressInfo }
                currentInfo.streetDirection = e.target.value
                setAddressInfo(currentInfo);
                methods.setValue("streetDirection", e.target.value);
                if (props.addressData != undefined && props.passAddressData != undefined) {
                  props.passAddressData(props.addressData.displayId, "streetDirection", e.target.value);
                }
                methods.clearErrors("streetDirection");
                setHighlightError(0);
              }}
            >
              <option hidden value="">Direction</option>
              <option value=" "></option>
              <option value="S">S</option>
              <option value="SE">SE</option>
              <option value="N">N</option>
              <option value="NW">NW</option>
              <option value="W">W</option>
              <option value="SW">SW</option>
              <option value="NE">NE</option>
              <option value="E">E</option>
            </select>
          </div>
        </div>
      </div>

      <div className={clsx("mt-5", focusErrorType == 5 ? "animate__animated animate__pulse" : "")}>
        <label htmlFor="cityName">City</label>
        <div className="flex relative">
          <span>
            <img
              src="assets/error-icon.svg"
              className={clsx(
                methods.formState?.errors?.cityName || addressErrors?.includes("city") ? "" : "hidden",
                "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[345px]"
              )}
              alt="error"
              height={5}
              width={5}
            />
          </span>
          <input
            className={clsx(
              methods.formState?.errors?.cityName?.message || addressErrors?.includes("city") ? "error" : "",
              "mt-2 w:[200px] md:w-[376px]", highlightError == 5 ? style.focusError : ""
            )}
            value={addressInfo.city}
            maxLength={40}
            onChange={(e) => {
              let currentInfo = { ...addressInfo }
              currentInfo.city = e.target.value
              setAddressInfo(currentInfo);
              methods.setValue("cityName", e.target.value);
              methods.clearErrors("cityName");
              setHighlightError(0);
            }}
            onBlur={(e) => {
              if (props.addressData != undefined && props.passAddressData != undefined) {
                props.passAddressData(props.addressData.displayId, "cityName", e.target.value);
              }
            }}
            type="text"
            id="cityName"
          />
        </div>
        {(methods.formState?.errors?.cityName?.message || addressErrors?.includes("city")) && (
          <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
            Enter your city name
          </span>
        )}
      </div>
      <div className="flex md:flex-row flex-col w-max">
        <div className={clsx("mt-5", focusErrorType == 6 ? "animate__animated animate__pulse" : "")}>
          {stateListType === 1 && <label htmlFor="province">Province</label>}
          {stateListType !== 1 && <label htmlFor="province">State</label>}
          {stateListType === 0 && <label htmlFor="province"> (Optional)</label>}
          <div className="flex relative">
            <span>
              <img
                src="assets/error-icon.svg"
                className={clsx(
                  methods.formState?.errors?.provinceName || addressErrors?.includes("province") ? "" : "hidden",
                  "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px]",
                  style.selectErrorImage
                )}
                alt="error"
                height={5}
                width={5}
              />
            </span>
            {stateListType === 1 || stateListType == 2 ?
              <select
                value={addressInfo.province}
                onChange={(e) => {
                  let currentInfo = { ...addressInfo }
                  currentInfo.province = e.target.value
                  setAddressInfo(currentInfo);
                  methods.setValue("provinceName", e.target.value);
                  if (props.addressData != undefined && props.passAddressData != undefined) {
                    props.passAddressData(props.addressData.displayId, "province", e.target.value);
                  }
                  methods.clearErrors("provinceName");
                  setHighlightError(0);
                }}
                className={clsx(
                  methods.formState?.errors?.provinceName?.message || addressErrors?.includes("province") ? "error" : "",
                  "mt-2 w:[200px] md:w-[222px] pt-2.5", highlightError == 6 ? style.focusError : ""
                )}
                id="province"
              >
                <option hidden value="">
                  {stateListType === 1 && "Province"}
                  {stateListType === 2 && "State"}
                </option>
                {stateListType === 1 && !props.forceOntario && <option value="AB">Alberta</option>}
                {stateListType === 1 && !props.forceOntario && <option value="BC">British Columbia</option>}
                {stateListType === 1 && !props.forceOntario && <option value="MB">Manitoba</option>}
                {stateListType === 1 && !props.forceOntario && <option value="NB">New Brunswick</option>}
                {stateListType === 1 && !props.forceOntario && <option value="NL">Newfoundland and Labrador</option>}
                {stateListType === 1 && !props.forceOntario && <option value="NS">Nova Scotia</option>}
                {stateListType === 1 && <option value="ON">Ontario</option>}
                {stateListType === 1 && !props.forceOntario && <option value="PE">Prince Edward Island</option>}
                {stateListType === 1 && !props.forceOntario && <option value="QC">Quebec</option>}
                {stateListType === 1 && !props.forceOntario && <option value="SK">Saskatchewan</option>}
                {stateListType === 1 && !props.forceOntario && <option value="NT">Northwest Territories</option>}
                {stateListType === 1 && !props.forceOntario && <option value="NU">Nunavut</option>}
                {stateListType === 1 && !props.forceOntario && <option value="YT">Yukon</option>}

                {stateListType === 2 && getStates}
              </select>
              :
              <input
                id="province"
                type="text"
                className={clsx(
                  methods.formState?.errors?.province?.message ? "error" : "",
                  "mt-2 w:[200px] md:w-[222px]"
                )}
                value={addressInfo.province}
                maxLength={4}
                onChange={(e) => {
                  let currentInfo = { ...addressInfo }
                  currentInfo.province = e.target.value;
                  setAddressInfo(currentInfo);
                  methods.setValue("provinceName", e.target.value);
                  methods.clearErrors("provinceName");
                  setHighlightError(0);
                }}
                onBlur={(e) => {
                  if (props.addressData != undefined && props.passAddressData != undefined) {
                    props.passAddressData(props.addressData.displayId, "province", e.target.value);
                  }
                }}
              />
            }
          </div>
          {(methods.formState?.errors?.provinceName?.message || addressErrors?.includes("province")) && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              {stateListType === 0 && "Enter your state"}
              {stateListType === 1 && "Select your province"}
              {stateListType === 2 && "Select your state"}
            </span>
          )}
        </div>
        <div className={clsx("md:ml-4 mt-5", focusErrorType == 7 ? "animate__animated animate__pulse" : "")}>
          <label htmlFor="postcode">
            {stateListType === 1 && "Postal Code"}
            {stateListType === 2 && "Zip Code"}
            {stateListType != 1 && stateListType != 2 && "Zip"}
            {stateListType === 0 && <label htmlFor="postcode"> (Optional)</label>}
          </label>
          <div className="flex relative">
            <span>
              <img
                src="assets/error-icon.svg"
                className={clsx(
                  methods.formState?.errors?.postalCode || addressErrors?.includes("postalCode") ? "" : "hidden",
                  "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px]  xs:max-md:ml-[370px] md:ml-[195px]"
                )}
                alt="error"
                height={5}
                width={5}
              />
            </span>
            <input
              id="postcode"
              type="text"
              className={clsx(
                methods.formState?.errors?.postalCode?.message || addressErrors?.includes("postalCode") ? "error" : "",
                "mt-2 w:[200px] md:w-[222px]", highlightError == 7 ? style.focusError : ""
              )}
              value={addressInfo.postalCode}
              maxLength={10}
              onChange={(e) => {
                let currentInfo = { ...addressInfo }
                currentInfo.postalCode = stateListType == 1 ? e.target.value.toUpperCase() : e.target.value
                setAddressInfo(currentInfo);
                methods.setValue("postalCode", e.target.value);
                methods.clearErrors("postalCode");
                setHighlightError(0);
              }}
              onBlur={(e) => {
                if (props.addressData != undefined && props.passAddressData != undefined) {
                  props.passAddressData(props.addressData.displayId, "postalCode", e.target.value);
                }
              }}
            />
          </div>{" "}
          {methods.formState?.errors?.postalCode?.type == "pattern" && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              Enter a valid postal code
            </span>
          )}
          {(methods.formState?.errors?.postalCode?.type == "required" || addressErrors?.includes("postalCode")) && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              {stateListType === 0 && "Enter your zip or area code."}
              {stateListType === 1 && "Enter your postal code"}
              {stateListType === 2 && "Enter your zip code"}
            </span>
          )}
        </div>
      </div>
      <div className="flex md:flex-row flex-col w-max">
        <div className={clsx("mt-5", focusErrorType == 8 ? "animate__animated animate__pulse" : "")}>
          <label htmlFor="country">Country</label>
          <div className="flex relative">
            <span>
              <img
                src="assets/error-icon.svg"
                className={clsx(
                  methods.formState?.errors?.country || addressErrors?.includes("country") ? "" : "hidden",
                  "w-4 h-4 absolute top-6  max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px]",
                  style.selectErrorImage
                )}
                alt="error"
                height={5}
                width={5}
              />
            </span>
            <div>
              <select
                id="country"
                className={clsx(
                  methods.formState?.errors?.country || addressErrors?.includes("country") ? "error" : "",
                  "mt-2 w:[200px] md:w-[222px] pt-2.5", highlightError == 8 ? style.focusError : "",
                  style.countryOption
                )}
                value={addressInfo.country}
                onChange={(e) => {
                  if (addressErrors == undefined || props.passAddressData != undefined) {
                    handleCaChange(e);
                  }
                  let currentInfo = { ...addressInfo }
                  currentInfo.country = e.target.value
                  currentInfo.province = "";
                  setAddressInfo(currentInfo);
                  methods.setValue("country", e.target.value);
                  if (props.addressData != undefined && props.passAddressData != undefined) {
                    props.passAddressData(props.addressData.displayId, "country", e.target.value);
                  }
                  methods.clearErrors("country");
                  setHighlightError(0);
                }}
              >
                <option hidden value="">
                  Country
                </option>
                {!props.forceOntario && !props.isRealEstateAsset && getCountry}
                {props.forceOntario && !props.isRealEstateAsset && <option value="Canada">Canada</option>}
                {!props.forceOntario && props.isRealEstateAsset && getNACountry}
              </select>
            </div>
          </div>
          {methods.formState?.errors?.country?.type == "country" && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              You must be a resident of Canada to complete this application.
            </span>
          )}
          {(methods.formState?.errors?.country?.type == "required" || addressErrors?.includes("country")) && (
            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
              Select your country
            </span>
          )}
        </div>
      </div>
    </>
  );
}
